import { ReactChild } from 'react';
import { MenuConfig } from '@tencent/workbench';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import i18n from '@i18next/i18n';


export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: MenuKey.ANONYMOUS_VIEW,
        content: i18n.t('隐身查看') as ReactChild,
        respectOffline: true,
    },
];
